import { getApp } from '../utils';

import { invalidateSession } from './invalidateSession';

/**
 * Ends the operator's session, locally first.
 *
 * The local teardown cannot be made to wait on the server, because the
 * cases that most need a logout are the ones where the server will not
 * answer. A restore is the clearest: the box comes back with a different
 * database, so the token this session holds authenticates against nothing
 * that exists. `app.logout()` then rejects, and a logout that awaited it
 * before clearing anything would leave the dead token in localStorage and
 * the userID populated — the app keeps reconnecting with it (4401, retry,
 * 4401) until it is rate limited, and the operator, still apparently
 * signed in, has to clear the key by hand to get back in.
 *
 * `invalidateSession` clears the token and the userID up front and treats
 * the server call as best effort, so the session is dead either way. That
 * makes the teardown synchronous; the promise stays in the signature
 * because callers await it before navigating.
 */
export function logout(): Promise<void> {
  invalidateSession(getApp());

  return Promise.resolve();
}
